/* src/app/payroll/third-party/payroll-item-association/payroll-item-association.component.scss */
body#themeTag :host ::ng-deep p-celleditor {
  min-width: 100%;
  max-width: 100%;
}
/*# sourceMappingURL=payroll-item-association.component.css.map */
